const SocialMedia = {
  Whatsapp: {
    id: 0,
    incentivado:
      "Você sabia que pode destinar o seu imposto de Renda para projetos sociais que impactam milhares de vidas? Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Saiba mais no link: [CAMPANHA]",
    semIncentivo:
      "Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Exerça sua cidadania e apoie as instituições sociais que estão transformando vidas. Saiba mais no link: [CAMPANHA]",
    projeto:
      "Texto simplificado para testes de compartilhamento de Projetos. [CAMPANHA]",
    vazio: "[CAMPANHA]",
    url: "https://wa.me/?text=[TEXT]",
  },
  Facebook: {
    id: 1,
    incentivado:
      "Você sabia que pode destinar o seu imposto de Renda para projetos sociais que impactam milhares de vidas? Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Saiba mais no link: [CAMPANHA]",
    semIncentivo:
      "Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Exerça sua cidadania e apoie as instituições sociais que estão transformando vidas. Saiba mais no link: [CAMPANHA]",
    projeto: "Texto simplificado para testes de compartilhamento de Projetos",
    vazio: "",
    url: "https://www.facebook.com/sharer/sharer.php?u=[URL]&quote=[TEXT]",
  },
  Twitter: {
    id: 2,
    incentivado:
      "Você sabia que pode destinar o seu imposto de Renda para projetos sociais que impactam milhares de vidas? Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Saiba mais no link: [CAMPANHA]",
    semIncentivo:
      "Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Exerça sua cidadania e apoie as instituições sociais que estão transformando vidas. Saiba mais no link: [CAMPANHA]",
    projeto: "Texto simplificado para testes de compartilhamento de Projetos",
    vazio: "",
    url: "https://twitter.com/intent/tweet?text=[TEXT]&url=[URL]",
  },
  Linkedin: {
    id: 3,
    incentivado:
      "Você sabia que pode destinar o seu imposto de Renda para projetos sociais que impactam milhares de vidas? Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Saiba mais no link: [CAMPANHA]",
    semIncentivo:
      "Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Exerça sua cidadania e apoie as instituições sociais que estão transformando vidas. Saiba mais no link: [CAMPANHA]",
    projeto: "Texto simplificado para testes de compartilhamento de Projetos",
    vazio: "Compartilhe",
    url:
      "https://www.linkedin.com/shareArticle?mini=true&summary=[TEXT]&url=[URL]",
  },
  Instagram: {
    id: 4,
    incentivado:
      "Você sabia que pode destinar o seu imposto de Renda para projetos sociais que impactam milhares de vidas? Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Saiba mais no link: [CAMPANHA]",
    semIncentivo:
      "Eu acabei de doar e gostaria de compartilhar com todos essa iniciativa. Exerça sua cidadania e apoie as instituições sociais que estão transformando vidas. Saiba mais no link: [CAMPANHA]",
    projeto: "Texto simplificado para testes de compartilhamento de Projetos",
    vazio: "",
    url: "",
  },
};

const GetSocialMediaLink = function(
  socialMedia,
  campaign,
  kindOfText,
  alternativeLink = null
) {
  let redirectLink = "";
  if (alternativeLink) {
    redirectLink = alternativeLink;
  } else {
    const host = window.location.host.split(".");
    const subdomain = host[0];
    redirectLink = window.location.protocol + "//" + subdomain + "." + host.slice(1).join(".");
  }

  switch (socialMedia) {
    case SocialMedia.Whatsapp:
      return socialMedia.url.replace(
        "[TEXT]",
        encodeURIComponent(
          socialMedia[kindOfText].replace("[CAMPANHA]", redirectLink)
        )
      );
    case SocialMedia.Facebook:
      return (
        socialMedia.url
          .replace("[TEXT]", encodeURIComponent(socialMedia[kindOfText]))
          .replace("[URL]", encodeURIComponent(redirectLink))
      );
    case SocialMedia.Twitter:
      return (
        socialMedia.url
          .replace("[TEXT]", encodeURIComponent(socialMedia[kindOfText]))
          .replace("[URL]", encodeURIComponent(redirectLink))
      );
    case SocialMedia.Linkedin:
      return (
        socialMedia.url
          .replace("[TEXT]", encodeURIComponent(socialMedia[kindOfText]))
          .replace("[URL]", encodeURIComponent(redirectLink))
      );
  }

  // if (hasProjectIncentivized) {
  //     switch (socialMedia) {
  //         case SocialMedia.Whatsapp:
  //             return socialMedia.url.replace('[TEXT]', encodeURIComponent(socialMedia.incentivado.replace('[CAMPANHA]', campaignLink)));
  //         case SocialMedia.Facebook:
  //             return "javascript:window.open('" + socialMedia.url.replace('[TEXT]', encodeURIComponent(socialMedia.incentivado)).replace('[URL]', encodeURIComponent(campaignLink)) + "','', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')";
  //         case SocialMedia.Twitter:
  //             return "javascript:window.open('" + socialMedia.url.replace('[TEXT]', encodeURIComponent(socialMedia.incentivado)).replace('[URL]', encodeURIComponent(campaignLink)) + "')";
  //         case SocialMedia.Linkedin:
  //             return "javascript:window.open('" + socialMedia.url.replace('[TEXT]', encodeURIComponent(socialMedia.incentivado)).replace('[URL]', encodeURIComponent(campaignLink)) + "','', '&source=MadeInTheMidlands&target=new,height=600,width=600')";
  //     }
  // } else {
  //     switch (socialMedia) {
  //         case SocialMedia.Whatsapp:
  //             return socialMedia.url.replace('[TEXT]', encodeURIComponent(socialMedia.semIncentivo.replace('[CAMPANHA]', campaignLink)));
  //         case SocialMedia.Facebook:
  //             return "javascript:window.open('" + socialMedia.url.replace('[TEXT]', encodeURIComponent(socialMedia.semIncentivo)).replace('[URL]', encodeURIComponent(campaignLink)) + "','', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')";
  //         case SocialMedia.Twitter:
  //             return "javascript:window.open('" + socialMedia.url.replace('[TEXT]', encodeURIComponent(socialMedia.semIncentivo)).replace('[URL]', encodeURIComponent(campaignLink)) + "')";
  //         case SocialMedia.Linkedin:
  //             return "javascript:window.open('" + socialMedia.url.replace('[TEXT]', encodeURIComponent(socialMedia.semIncentivo)).replace('[URL]', encodeURIComponent(campaignLink)) + "','', '&source=MadeInTheMidlands&target=new,height=600,width=600')";
  //     }
  // }
};

const LoginSocialMedia = {
  Facebook: 1,
  Google: 2,
  Microsoft: 3,
};

export { SocialMedia, GetSocialMediaLink, LoginSocialMedia };
